import specialtiesCheckDialog from './specialtiesCheckDialog';

export default {
	specialtiesCheckDialog
};
